import { configurationSettings, getOrderItemCount, getOrderItemCountByItemId } from '@vista/omnichannel-components-domain';
export const getAllowedMaxQuantityForItem = (itemQuantityLimit, sellableItem, priceRestriction, maximumItemsPerOrder = configurationSettings.data.order.maximumItemsPerOrder) => {
    const smallestAllowedMax = !itemQuantityLimit.isUnlimited && itemQuantityLimit.maximum
        ? Math.min(maximumItemsPerOrder, itemQuantityLimit.maximum)
        : maximumItemsPerOrder;
    const max = smallestAllowedMax + getOrderItemCountByItemId(sellableItem.itemId, priceRestriction) - getOrderItemCount(); // Including the quantity already added to the order for the given item for editing
    return max;
};
